import Button from "~/components/ui/Button";
import Icon from "~/components/ui/Icon";
import { useUI } from "~/sdk/useUI";

function MenuButton() {
  const { displayMenu } = useUI();

  return (
    <Button
      className="btn btn-circle btn-sm btn-ghost"
      aria-label="Abrir menu"
      onClick={() => {
        displayMenu.value = true;
      }}
    >
      <Icon id="Bars3" size={24} strokeWidth={0.01} />
    </Button>
  );
}

export default MenuButton;
